import { styled } from '@material-ui/core/styles';
import React, { Fragment } from 'react';
import Box from '../Box';
import SegmentInput from './SegmentInput';
import { useSegmentedDateInput } from './useSegmentedDateInput';
import { CalendarIcon } from '../Icon';
var DateInputContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        width: '160px',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'flex-start',
        border: "1px solid " + theme.palette.divider,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1, 0.75),
        backgroundColor: theme.palette.background.paper,
        '&:focus-within': {
            borderColor: theme.palette.primary.main,
            boxShadow: "0 0 0 1px " + theme.palette.primary.main,
        },
        '&.error': {
            borderColor: theme.palette.error.main,
            '&:focus-within': {
                borderColor: theme.palette.error.main,
                boxShadow: "0 0 0 1px " + theme.palette.error.main,
            },
        },
    });
});
var DateSeparator = styled('span')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.typography.body1.fontSize,
        color: theme.palette.text.secondary,
    });
});
var LabelContainer = styled('label')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'block',
        marginBottom: theme.spacing(1),
        fontSize: theme.typography.caption.fontSize,
        fontWeight: theme.typography.caption.fontWeight,
        color: theme.palette.text.secondary,
        '&.error': {
            color: theme.palette.error.main,
        },
    });
});
var HelperText = styled('p')(function (_a) {
    var theme = _a.theme;
    return ({
        margin: theme.spacing(0.5) + "px 0 0 0",
        fontSize: theme.typography.caption.fontSize,
        color: theme.palette.text.secondary,
        '&.error': {
            color: theme.palette.error.main,
        },
    });
});
var SegmentedDateInput = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, onChange = _a.onChange, onClick = _a.onClick, label = _a.label, error = _a.error, helperText = _a.helperText;
    var _c = useSegmentedDateInput({ value: value, onChange: onChange }), monthRef = _c.monthRef, dayRef = _c.dayRef, yearRef = _c.yearRef, segments = _c.segments, handleSegmentChange = _c.handleSegmentChange, handleSegmentKeyDown = _c.handleSegmentKeyDown, handleSegmentClick = _c.handleSegmentClick, handleSegmentFocus = _c.handleSegmentFocus;
    var segmentDetails = [
        { type: 'month', ref: monthRef },
        { type: 'day', ref: dayRef },
        { type: 'year', ref: yearRef },
    ];
    return (React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "space-between" },
        label && (React.createElement(LabelContainer, { className: error ? 'error' : '' }, label)),
        React.createElement(DateInputContainer, { className: error ? 'error' : '', onClick: onClick, style: { cursor: onClick ? 'pointer' : 'default' } },
            segmentDetails.map(function (segment, index) { return (React.createElement(Fragment, { key: segment.type },
                React.createElement(SegmentInput, { type: segment.type, inputRef: segment.ref, value: segments[segment.type], onChange: function (e) { return handleSegmentChange(segment.type, e.target.value); }, onKeyDown: function (e) { return handleSegmentKeyDown(segment.type, e); }, onClick: function () { return handleSegmentClick(segment.type); }, onFocus: function () { return handleSegmentFocus(segment.type); } }),
                index < segmentDetails.length - 1 && (React.createElement(DateSeparator, null, "/")))); }),
            React.createElement(Box, { display: "flex", alignItems: "center", marginLeft: "auto" },
                React.createElement(CalendarIcon, { fontSize: "small" }))),
        helperText && (React.createElement(HelperText, { className: error ? 'error' : '' }, helperText))));
};
export default SegmentedDateInput;
